import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	padding-bottom: var(--gap);
	flex: 1;
	gap: var(--gap);
`;
